// Please create all  new category
// inside theme object as
// to make sure all server by one theme
const baseColor = {
  blue400: '#001b4d',
  blue300: '#0238b3',
  blue200: '#0033e8',
  blue100: '#4574ff',
  blue50: '#d5e1ff',
  blue20: '#f5f6fa',

  rosiness: '#e72a58',
  orange: '#ffac27',

  white: '#ffffff',
  grey50: '#ecf0f3',
  grey80: '#e3e3e3',
  grey100: '#cacfd1',

  grey200: '#c6c6c6',
  grey300: '#9fa3a6',
  grey400: '#838383',
  grey500: '#6a6a6a',
  grey600: '#525252',

  dark100: '#3b3b3b',
  dark200: '#252525',

  black: '#000000',
}

export const defaultColor = {
  pagebgColor: 'initial',
  primary: baseColor.blue200, // 'rgb(0, 51, 232)',
  bgColor: baseColor.blue20, // 'rgb(245, 246, 250)',
  modalColor: '#1a1e28', // 'rgb(26, 30, 40)',
  modalBgColor: baseColor.white,
  modalDescriptionColor: '#525252',
  modalFirstButtonColor: '#464d57',
  modalCloseButtonColor: '#333',

  importantColor: '#ff001b', // rgb(255, 0, 27),
  buttonBgColor: baseColor.blue200,
  buttonColor: baseColor.white,
  disableButtonColor: 'rgba(255, 255, 255, 0.38)',
  disableButtonBgColor: 'rgb(162, 181, 249)',
  tagColor: baseColor.orange, // 热门，限兑
  homeTabBgColor: baseColor.white,
  homeTabColor: 'rgba(26, 30, 40, 0.3)',

  masterTitle: '#03070f', // rgb(3, 7, 15),
  subTitle: '#9f9f9f', // rgb(159, 159, 159)
  skuDetailBg: '#e8eaf6',
  skuCardRightBg: 'rgba(255, 255, 255, 0.85)',
  skuQuotaLabelColor: baseColor.black,
  skuPointsLabelColor: baseColor.blue300,
  skuTextOverhangGradient:
    'linear-gradient(to bottom, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.8))',

  contentPrimaryBgColor: baseColor.white,
  descriptionBgColor: baseColor.blue20,
  bottomBarBgColor: baseColor.white,
  bottomBarColor: baseColor.dark200,
  termsColor: baseColor.black,
  infoColor: '#1a1e28', // rgb(26,30,40)
  tncColor: baseColor.dark200,
  borderColor: '#e3e3e3',
  couponSubTitle: 'rgb(60, 67, 78)',
  couponDisableColor: 'rgba(255, 255, 255, 0.75)',
  textCodeColor: baseColor.dark200,
  copyButtonColor: 'rgba(255,255,255,0.87)',

  contentLoader: {
    backgroundColor: '#e3e3e3',
    foregroundColor: '#f3f3f3',
  },
  countdownColor: baseColor.white,

  navigationDistinctColor: '#1a1e28',
  navigationColor: '#fbfcfd',
  navigationTitleColor: '#1a1e28',

  pinInput: {
    activeBorderColor: 'rgb(69, 116, 225)',
    borderColor: 'rgb(217, 217, 217)',
    color: 'initial',
  },

  keyboard: {
    bgColor: baseColor.white,
    borderColor: baseColor.grey80,
    numberColor: baseColor.black,
    dismissBarBgColor: baseColor.grey50,
    dismissBarBorderColor: baseColor.grey100,
  },

  topSafeAreaBgColor: 'transparent',

  ...baseColor,
}
export const darkModeColor = {
  pagebgColor: '#121212',
  primary: '#5294FF',
  bgColor: '#121212',
  modalColor: 'rgba(255, 255, 255, 0.87)',
  modalDescriptionColor: 'rgba(255, 255, 255, 0.87)',
  modalBgColor: '#3c3c3c',
  modalFirstButtonColor: 'rgba(255, 255, 255, 0.87)',
  modalCloseButtonColor: 'rgba(255, 255, 255, 0.87)',

  homeTabBgColor: '#2c2c2c',
  homeTabColor: 'rgba(255, 255, 255, 0.38)',

  importantColor: '#f07f9a',
  buttonBgColor: '#5294ff',
  buttonColor: 'rgba(255, 255, 255, 0.87)',
  disableButtonColor: 'rgba(255, 255, 255, 0.38)',
  disableButtonBgColor: '#3C3C3C',
  tagColor: '#ffcd7d', // 热门，限兑

  masterTitle: 'rgba(255, 255, 255, 0.87)', // rgb(3, 7, 15),
  subTitle: 'rgba(255, 255, 255, 0.6)', // rgb(159, 159, 159)
  skuDetailBg: '#121212',
  skuCardRightBg: '#242424',
  skuQuotaLabelColor: 'rgba(255, 255, 255, 0.87)',
  skuPointsLabelColor: '#5294ff',
  skuTextOverhangGradient:
    'linear-gradient(to bottom, rgba(36, 36, 36, 0), #242424)',

  contentPrimaryBgColor: '#242424',
  descriptionBgColor: '#1e1e1e',
  bottomBarBgColor: '#2c2c2c',
  bottomBarColor: 'rgba(255, 255, 255, 0.87)',
  termsColor: 'rgba(255, 255, 255, 0.6)',
  infoColor: 'rgba(255, 255, 255, 0.87)',
  tncColor: 'rgba(255, 255, 255, 0.6)',
  borderColor: 'rgba(255, 255, 255, 0.08)',
  couponSubTitle: 'rgba(255, 255, 255, 0.6)',
  couponDisableColor: 'rgba(18, 18, 18, 0.75)',
  textCodeColor: 'rgba(255, 255, 255, 0.87)',
  copyButtonColor: baseColor.black,

  contentLoader: {
    backgroundColor: '#2c2c2c',
    foregroundColor: '#3c3c3c',
  },
  countdownColor: baseColor.black,

  navigationDistinctColor: 'rgba(255, 255, 255, 0.87)',
  navigationColor: '#2c2c2c',
  navigationTitleColor: 'rgba(255, 255, 255, 0.6)',

  pinInput: {
    activeBorderColor: '#5294ff',
    borderColor: 'rgba(255, 255, 255, 0.08)',
    color: 'rgba(255, 255, 255, 0.87)',
  },

  keyboard: {
    bgColor: '#3c3c3c',
    borderColor: 'rgba(255, 255, 255, 0.08)',
    numberColor: 'rgba(255, 255, 255, 0.87)',
    dismissBarBgColor: '#3c3c3c',
    dismissBarBorderColor: 'rgba(255, 255, 255, 0.08)',
  },

  topSafeAreaBgColor: '#2C2C2C',

  ...baseColor,
}

const theme = {
  color: (() => {
    if (typeof window !== 'undefined') {
      const matchResult = window.navigator.userAgent.match(/\bdarkMode\/(\w+)/)
      const dark = matchResult ? matchResult[1].toLowerCase() === 'true' : false
      return dark ? darkModeColor : defaultColor
    }
    return defaultColor
  })(),
  media: {
    iPhoneSE:
      'only screen and (device-width: 320px)and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait)',
    iPhonePlus:
      'only screen and (device-width: 414px)and (-webkit-min-device-pixel-ratio: 3) and (orientation: portrait)',
    iPhoneX:
      'only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3)',
    generalSafeAreaForIphoneXAbove:
      'only screen and (min-device-width: 375px) and (min-device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)',
    generalSafeAreaForXR:
      'only screen and (min-device-width: 414px) and (min-device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)',
  },

  defaultIphoneSafeAreaSpace: '34px',

  desktopMaxWidth: '1280px',
  tabletLandscape: 1023,
  desktopLandscape: 1024,
  mobileLandscape: 599,
}

export const tabletSize = `(max-width: ${theme.tabletLandscape}px)`
export const desktopSize = `(min-width: ${theme.desktopLandscape}px)`
export const mobileSize = `(max-width: ${theme.mobileLandscape}px)`

export const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 1024,
    lg: 1280,
    xl: 1920,
  },
}

export default theme
